import React from 'react';

import { connect } from "react-redux";
import classes from "./App.css";
import Part1 from "../Part1/Part1";
import Part2 from "../Part2/Part2";
import './App.css';
import Navbar from '../Navbar/Navbar';

const App = (props) => {
  return (
    <React.Fragment>
      <Navbar />

    </React.Fragment>);
}

const mapStateToProps = (state) => {
  return {

    counter: state.c
  }
}

const mapDispatchToProps = (emit) => {
  return {
    onClicked: (evt) => emit({ type: 'alert', evt })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
